{
  "hero": {
    "eyebrow": "Science",
    "title": "Why mobile, location-linked monitoring matters.",
    "lead": "Water quality changes across space and after rainfall. AquaWorks turns repeatable route-based readings into maps and trends students can interpret—without claiming laboratory certainty."
  },
  "problem": {
    "title": "Background and problem",
    "body": "Manual sampling often captures only a few fixed points. In stormwater-connected environments, rainfall can move sediment, road-derived particles, nutrients, and other materials into ponds and receiving waters. Conditions can differ metres apart and shift quickly after storms.",
    "points": [
      "Regional research links tire-derived chemicals such as 6PPD-quinone to acute impacts on coho salmon after rainfall—showing why runoff pathways matter.",
      "Nutrient pollution can drive algal blooms and low-oxygen conditions in lakes, ponds, and coastal waters.",
      "Turbidity is a practical Phase 1 field indicator: suspended particles affect habitats and can transport phosphorus, metals, and other pollutants."
    ]
  },
  "campus": {
    "title": "Stormwater context on the Vancouver campus",
    "body": "The Vancouver campus Integrated Stormwater Management Plan and sustainability reporting highlight stormwater quality as a long-term goal. SEEDS work on rain gardens and green rainwater infrastructure shows continued need for rainfall-related measurements of temperature, pH, conductivity, dissolved oxygen, and turbidity.",
    "note": "AquaWorks complements fixed infrastructure with mobile, spatially distributed observations during controlled tests—not ownership of campus monitoring programs."
  },
  "parameters": {
    "eyebrow": "Phase 1 sensors",
    "title": "Five core water-quality indicators",
    "note": "These characterize general conditions and spatial or temporal variation. They do not confirm specific contaminants or regulatory compliance.",
    "items": {
      "temperature": {
        "name": "Temperature",
        "description": "Shapes dissolved oxygen, biological processes, and how other indicators behave."
      },
      "ph": {
        "name": "pH",
        "description": "Acidity or alkalinity, sensitive to biological activity and surrounding conditions."
      },
      "turbidity": {
        "name": "Turbidity",
        "description": "Optical signal of suspended particles—useful for runoff and stormwater pattern detection."
      },
      "conductivity": {
        "name": "Electrical conductivity",
        "description": "Indicates dissolved ionic content; useful for comparing sites along a route."
      },
      "dissolvedOxygen": {
        "name": "Dissolved oxygen",
        "description": "Essential for aquatic life; verified using manufacturer procedures in Phase 1."
      }
    }
  },
  "spatial": {
    "title": "Spatial and temporal observation",
    "body": "Readings are linked to timestamps and spatial references—waypoints, route segments, GPS where feasible, or defined test zones. Before-and-after rainfall comparisons along the same route make change visible."
  },
  "viz": {
    "title": "From CSV to spatial story",
    "body": "Raw and processed files stay separate. Outputs include route maps, time-series and parameter trends, and at least one spatial map where colour or height represents an indicator across the monitored area. Interpolation assumptions are documented; measurement points remain visible."
  },
  "sdgs": {
    "title": "SDG alignment",
    "lead": "Education, clean water awareness, innovation, sustainable communities, responsible production, climate resilience literacy, life below water, and partnerships.",
    "items": {
      "education": "Quality Education",
      "water": "Clean Water and Sanitation",
      "innovation": "Industry, Innovation and Infrastructure",
      "cities": "Sustainable Cities and Communities",
      "consumption": "Responsible Consumption and Production",
      "climate": "Climate Action",
      "lifeBelowWater": "Life Below Water",
      "partnerships": "Partnerships for the Goals"
    }
  },
  "sources": {
    "title": "Selected references",
    "lead": "Framing draws on peer-reviewed research, provincial guidance, Vancouver campus planning documents, and SEEDS reports cited in the project proposal."
  }
}
